import * as fetcher from "../fetcher";

export const dissasociateAppointment = (
  projectdId: number,
  appointmentId?: string
) => {
  if (!projectdId || !appointmentId) {
    return null;
  }
  return fetcher.opportunity.remove(
    `/${projectdId}/appointments/${appointmentId}`
  );
};
